import Intro from "../../components/intro/Intro";
import BigPicture from "../../components/pictures/BigPicture";

const Oregon = () => {
  const pictures = [
    {
      title: "MULTNOMAH FALLS",
      description: (
        <p className="o64">
          This waterfall is a sight to behold! Two waterfalls (and a gorgeous
          bridge) for the price of one?! Get real. We stayed here for a while
          just staring at it.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/multnomah_talls.jpg",
      alt: "a full vertical view of multnomah falls.",
    },
    {
      title: "MULTNOMAH FALLS 2",
      description: (
        <p className="o64">
          Here's another picture of only the bridge and lower falls. Plus, it's
          right off the road, making this a 10/10 road trip pit stop.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/multnomah_falls.jpg",
      alt: "a full vertical view of multnomah falls.",
    },
    {
      title: "AMPHITHEATER",
      description: (
        <p className="o64">
          We visited the International Rose Test Garden too early: nothing was
          in bloom, and it was mostly sticks and dirt. But the scenery was
          gorgeous anyway, like this amphitheater.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/amphitheater.jpg",
      alt: "an amphitheater in the interantional rose test garden.",
    },
    {
      title: "OCEAN WAVES",
      description: [
        <p className="o64">
          Anika and I saw two (or more) whales! We stopped at a random turnout
          (not even an official viewpoint) to adjust our luggage and were about
          to leave when Anika said, "Is that a whale?!" Sure enough, it was! We
          spent about 15 minutes watching two whales that were <i>incredibly</i>{" "}
          close to the shore. People spend a lot of time, energy, and money for
          an experience like that!
        </p>,
        <p className="o64" style={{ marginTop: "0.5rem" }}>
          Anyway, this is the same place we saw the whales, just... without the
          whales. (Anika has a bunch of videos of them that we can show you.)
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/nature/waves.jpg",
      alt: "ocean waves.",
    },
    {
      title: "AZALEAS",
      description: (
        <p className="o64">
          There were so many azaleas in bloom that really were this vibrantly
          pink! I've never seen anything like it. I thought it was my new
          favorite tree until I looked it up and learned that it is a shrub.
          So... it's my new favorite shrub.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/azaleas.jpg",
      alt: "pink azaleas in full bloom.",
    },
    {
      title: "NATURAL BRIDGES",
      description: (
        <p className="o64">
          "Natural Bridges" was one of the coolest viewpoints. The arches are
          neat, and it's cool to see cliffs, forest, and the ocean at the same
          time. The proximity of the beach and mountains is so cool in general,
          and it's like that along the entire coast.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/natural_bridges.jpg",
      alt: "natural bridges in oregon.",
    },
    {
      title: "ANIKA",
      description: (
        <p className="o64">
          Anika at the beach. She is so pretty and fun and I absolutely{" "}
          <i>loved</i> road-tripping with her. It was a perfect trip, largely
          because she was there.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/anika_shat.jpg",
      alt: "anika at the beach.",
    },
    {
      title: "SPLIT ROCK BEACH",
      description: (
        <p className="o64">
          This was taken from the middle of a giant rock (about 20 feet tall and
          20 feet wide that tapered to a point, poking out of the sand like the
          peak of a mountain) that had been split in two, which is cool in
          concept and also makes for a neat view.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/split_rock_beach.jpg",
      alt: "split rock beach.",
    },
    {
      title: "ZACK",
      description: (
        <p className="o64">
          Zack (and others) joined us on one of our early-morning adventures to
          catch low tide. The amount of random creatures in the nooks and
          crannies of the rocks was incredible. (Zack seemed pretty excited
          about it, anyway.)
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/zack.jpg",
      alt: "zack at the beach",
    },
    {
      title: "STARFISH",
      description: (
        <p className="o64">
          I just—I knew they had little suckers... but like... I don't know; I
          guess it didn't really hit me until this moment. That's awesome. But
          also, ew.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/starfish.jpg",
      alt: "a starfish holding on.",
    },
    {
      title: "CRAB",
      description: (
        <p className="o64">
          There are so many crabs there! Definitely not a creature I'm used to
          running into in the wild. I like them; they're weird and interesting.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/crab.jpg",
      alt: "a crab hiding in a crevace.",
    },
    {
      title: "GROOM + BRIDE",
      description: (
        <p className="o64">
          Max and Ashley, right after getting married. The entire wedding was an
          absolute dream! Love and magic were in the air!
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/makshley.jpg",
      alt: "max and ashley.",
    },
    {
      title: "CHETCO POINT PARK",
      description: (
        <p className="o64">
          Ahead of you is the magical cliffside that the next few pictures were
          taken on. (And, unfortunately, almost immediately behind you is a
          waste water treatment plant. Sorry.)
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/chetco_point.jpg",
      alt: "chetco point.",
    },
    {
      title: "MAX",
      description: [
        <p className="o64">
          Max looked great. (So did Ashley, but I didn't get a picture of her.
          They had a professional photographer there, so I stayed out of the way
          and didn't have them pose for me at all; I just snuck some pictures
          when I could.)
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/portrait/max.jpg",
      alt: "max looking fresh af",
    },
    {
      title: "CLIFFSIDE COUPLE",
      description: (
        <p className="o64">
          Yes, this moment was, in fact, as magical as it looks. Except they
          were a lot closer to the edge of that cliff than it seems. (Some would
          say too close.)
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/cliff_makshley.jpg",
      alt: "max and ashley sitting on a cliff",
    },
    {
      title: "CLIFFSIDE COUPLE 2",
      description: (
        <p className="o64">Okay, you can get off the cliff now! Thanks!</p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/portrait/makshley_cliff.jpg",
      alt: "max and ashley sitting on a cliff",
    },
    {
      title: "OZZY'S PORTAL",
      description: [
        <p className="o64">"That looks like a portal!"</p>,
        <p className="o64" style={{ marginTop: "0.5rem" }}>
          — Ozzy
        </p>,
        <p className="o64" style={{ marginTop: "0.5rem" }}>
          (He's right.)
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/ozzy_portal.jpg",
      alt: "ozzy's portal.",
    },
    {
      title: "FLOWER",
      description: (
        <p className="o64">
          This was one of the prettiest flowers I've ever seen! I genuinely have
          been waiting <i>such</i> a long time for a picture like this: a pretty
          flower with a lush green background. It is simply delightful.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/flower.jpg",
      alt: "a perfect flower.",
    },
    {
      title: "LOVE BEACH",
      description: (
        <p className="o64">
          Zack and Madi's kids frolicked in the waves while the group played
          "Conquer the World" on the beach. Good thing I hate that game and
          enjoy taking pictures because this one turned out great!
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/conquer_the_beach.jpg",
      alt: "friends and family on the beach.",
    },
    {
      title: "LOVE BEACH 2",
      description: (
        <p className="o64">
          Another view of (almost) everyone playing on the beach, but this time
          we're close enough to see some details, like Seth and Emma being more
          interested in a mound of sand than "Conquer[ing] the World" and Anika
          playing with the kids in the background.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/beach_max.jpg",
      alt: "max's friends and family on the beach.",
    },
    {
      title: "FAMILY ROAD TRIP",
      description: (
        <p className="o64">
          On our way to visit the redwoods, my Dad drove ahead of us—with the entire family in the car—giving me the
          opportunity to take this picture. There are a lot of people in that van!
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/lifestyle/road_trip.jpg",
      alt: "a white van on a road trip.",
    },
    {
      title: "SNAIL",
      description: (
        <p className="o64">
          This is one of the coolest snails I've seen! We spotted him while he
          was exploring the redwoods. He is adorable (and quite large).
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/snail.jpg",
      alt: "a snail in the redwoods.",
    },
    {
      title: "MISTY VALLEY",
      description: (
        <p className="o64">
          The scenery in Oregon is spectacular. (We said "Woah! Look at that!"
          about every 10 seconds.) We passed a section where there were misty
          valleys like this one everywhere, but we were a bit behind schedule,
          so I had to be more picky about where we stopped. I chose to stop here
          after passing it on the freeway. I turned the car around, pulled over,
          sprinted a decent ways, and got this shot just in time for the crow
          flying by.
        </p>
      ),
      src: "https://storage.googleapis.com/squidslippers-media/nature/misty_valley.jpg",
      alt: "a misty valley, featuring a crow flying overhead.",
    },
    {
      title: "AVENUE OF THE GIANTS",
      description: [
        <p className="o64">
          On our way home, we stopped at a coffee shop and got a recommendation
          from a stranger to visit "Avenue of the Giants", an optional scenic
          road that tangles with the highway on a map. (Except instead of going
          over the trees, it weaves through them.) We checked and saw that it
          added several hours to our trip—it takes longer since it's a slower
          road, but on top of that, we had planned on taking a different route
          entirely—and we estimated that if we took the route, we'd get to our
          hotel around 1 AM instead of 10 PM like we'd planned.
        </p>,
        <p className="o64" style={{ marginTop: "0.5rem" }}>
          We went anyway. And it was well worth the late night! Truly a
          life-changing experience.
        </p>,
        <p className="o64" style={{ marginTop: "0.5rem" }}>
          The name checks out: there were giant old growth redwood trees{" "}
          <i>everywhere</i>. We could stop almost any time and wander into the
          woods. I've never experienced anything like it.
        </p>,
      ],
      src: "https://storage.googleapis.com/squidslippers-media/nature/redwood_avenue.jpg",
      alt: "the avenue of the giants.",
    },
  ];
  return (
    <div className="main">
      <Intro
        primary="OREGON"
        secondary="hi grandma and grandpa! if you're hoping to see all of the pictures from our trip to oregon..."
        tertiary="you're in the right place."
      />
      <div className="column p01">
        {pictures.map((picture, index) => (
          <BigPicture
            alt={picture.alt}
            description={picture.description}
            src={picture.src}
            title={picture.title}
          />
        ))}
      </div>
    </div>
  );
};

export default Oregon;
